import React from 'react';
import { Avatar } from '@mui/material';
import { Person } from '@mui/icons-material';

interface UserAvatarProps {
  photoUrl?: string | null;
  name: string;
  size?: number;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ 
  photoUrl, 
  name, 
  size = 40 
}) => {
  // 이름에서 첫 글자 추출 (한글/영문 지원)
  const getInitials = (name: string): string => {
    if (!name) return '?';
    
    // 한글인 경우 첫 글자만
    if (/[가-힣]/.test(name)) {
      return name.charAt(0);
    }
    
    // 영문인 경우 첫 글자들의 조합
    const words = name.trim().split(' ');
    if (words.length === 1) {
      return words[0].charAt(0).toUpperCase();
    }
    
    return words
      .slice(0, 2)
      .map(word => word.charAt(0).toUpperCase())
      .join('');
  };

  // 이름 기반 색상 생성
  const getAvatarColor = (name: string): string => {
    const colors = [
      '#1976d2', '#dc004e', '#9c27b0', '#673ab7',
      '#3f51b5', '#2196f3', '#03a9f4', '#00bcd4',
      '#009688', '#4caf50', '#8bc34a', '#cddc39',
      '#ffc107', '#ff9800', '#ff5722', '#795548',
      '#607d8b', '#e91e63', '#9e9e9e', '#7b1fa2'
    ];
    
    const hash = name
      .split('')
      .reduce((acc, char) => char.charCodeAt(0) + acc, 0);
    
    return colors[hash % colors.length];
  };

  if (photoUrl) {
    return (
      <Avatar
        src={photoUrl}
        alt={name}
        sx={{ 
          width: size, 
          height: size,
          border: '2px solid #f0f0f0'
        }}
      />
    );
  }

  return (
    <Avatar
      sx={{ 
        width: size, 
        height: size,
        backgroundColor: getAvatarColor(name),
        color: 'white',
        fontWeight: 'bold',
        fontSize: size * 0.4
      }}
    >
      {name ? getInitials(name) : <Person />}
    </Avatar>
  );
};

export default UserAvatar;
